import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Popover, Transition } from '@headlessui/react';
import PropTypes from 'prop-types';
import { Fragment, useRef } from 'react';
import Aptive from '../../../../assets/img/aptive.svg';
import Cross from '../../../../assets/img/cross.svg';
import Mover from '../../../../assets/img/mover.svg';
import Refinanced from '../../../../assets/img/refinanced.svg';
import Skull from '../../../../assets/img/skull.svg';
import { dictionary } from '../../../../lang';
import { MAP_LEGEND } from '../../../../lib/constants';
import LegendKey from './LegendKey';
import MapLegendIcon from './MapLegendIcon';
import MapLegendItem from './MapLegendItem';
import PinLegend from './PinLegend';
const MapLegend = ({ data, pinMode, isPolygons, displayPins, displayPinsOutcomes, }) => {
    const buttonRef = useRef(null);
    const timeoutDuration = 200;
    let timeout;
    const closePopover = () => {
        return buttonRef.current?.dispatchEvent(new KeyboardEvent('keydown', {
            key: 'Escape',
            bubbles: true,
            cancelable: true,
        }));
    };
    const onMouseEnter = (open) => () => {
        clearTimeout(timeout);
        if (open) {
            return;
        }
        return buttonRef.current?.click();
    };
    const onMouseLeave = (open) => () => {
        if (!open) {
            return;
        }
        timeout = setTimeout(() => closePopover(), timeoutDuration);
    };
    return (_jsx(Popover, { children: ({ open }) => {
            return !isPolygons && !displayPins && pinMode
                ? null
                : (_jsxs(_Fragment, { children: [_jsx(Popover.Button, { ref: buttonRef, className: "absolute bottom-[26px] right-[70px] z-[800] bg-clip-padding border-2 border-black/20 bg-white hover:bg-gray-50 rounded outline-none", onMouseEnter: onMouseEnter(open), onMouseLeave: onMouseLeave(open), children: _jsx("div", { className: "w-11 h-11 bg-white rounded flex items-center justify-center", children: _jsx(MapLegendIcon, { className: "w-7 h-7" }) }) }), _jsx(Transition, { as: Fragment, enter: "transition ease-out duration-200", enterFrom: "opacity-0 translate-y-1", enterTo: "opacity-100 translate-y-0", leave: "transition ease-in duration-150", leaveFrom: "opacity-100 translate-y-0", leaveTo: "opacity-0 translate-y-1", children: _jsx(Popover.Panel, { static: true, className: "absolute right-[70px] bottom-[100px] z-[800] min-w-[366px] max-w-[534px]", children: _jsxs("div", { className: "bg-white rounded-lg p-6 relative", onMouseEnter: onMouseEnter(open), onMouseLeave: onMouseLeave(open), children: [_jsx("div", { className: "absolute right-[14px] -bottom-[7px] w-5 h-5 bg-white rounded-sm rotate-45 z-[-1]" }), ((!displayPins && pinMode) || data.legend.length === 0)
                                            ? null
                                            : (_jsx(MapLegendItem, { title: pinMode ? dictionary.PINS : data.title, isDivider: isPolygons, children: data.legend.map((item) => (_jsx(LegendKey, { name: item.legend, style: pinMode ? { background: item.fill, border: `1px solid ${item.stroke}` } : { background: item.fillColor } }, item.legend))) })), isPolygons && (_jsx(MapLegendItem, { title: dictionary.POLYGONS, isDivider: displayPins && data?.isIcons, children: MAP_LEGEND.POLYGONS.map((item) => (_jsx(LegendKey, { name: item.legend, style: { background: item.color } }, item.legend))) })), (displayPins && data.isIcons) && (_jsxs(MapLegendItem, { title: dictionary.ICONS, isDivider: displayPinsOutcomes, children: [_jsx(LegendKey, { name: dictionary.NEW_MOVER, image: Mover }, dictionary.NEW_MOVER), _jsx(LegendKey, { name: dictionary.RECENT_REFINANCED, image: Refinanced }, dictionary.RECENT_REFINANCED), _jsx(LegendKey, { name: dictionary.PREVIOUS_CUSTOMER, image: Aptive }, dictionary.PREVIOUS_CUSTOMER), _jsx(LegendKey, { name: dictionary.DO_NOT_KNOCK_ADMIN, image: Skull }, dictionary.DO_NOT_KNOCK_ADMIN), _jsx(LegendKey, { name: dictionary.DO_NOT_KNOCK_REP, image: Cross }, dictionary.DO_NOT_KNOCK_REP)] })), (displayPins && displayPinsOutcomes) && (_jsx(MapLegendItem, { title: dictionary.PINS, children: MAP_LEGEND.OUTCOME_PINS.map((item) => (item.legend ? (_jsx(PinLegend, { name: item.legend, item: item, type: "outcome" }, item.legend)) : null)) }))] }) }) })] }));
        } }));
};
MapLegend.propTypes = {
    data: PropTypes.shape({
        title: PropTypes.string,
        legend: PropTypes.array,
        isIcons: PropTypes.bool,
    }),
    pinMode: PropTypes.bool,
    isPolygons: PropTypes.bool,
    displayPins: PropTypes.bool,
    displayPinsOutcomes: PropTypes.bool,
};
export default MapLegend;
